import gql from 'graphql-tag';

export const validWalletAddress = gql`
  query isAddressValid($networkId: String!, $address: String!) {
    isAddressValid(networkId: $networkId, address: $address) {
      isValid
    }
  }
`;
